//* This file contains the export files statement which will be export again in the pages

// ----------------- Common Library -----------------
export {AnimatePresence, API, axios, Button, ButtonStyle, Component, Congrats, DataFromUrl, ErrorMessage, faExclamationCircle, faTimes, 
        Field, FieldArray, FontAwesomeIcon, Form, Formik, FormikControl, FormStyle, getIn, getSession, goToNextPage, Image, 
        Link, motion, MobileMenubar, NextServerCookies, PAGE_ANIMATION_OPTIONS, React, REDIRECT, Sidebar, signIn, 
        SUCCESS_REPONSE_CODE, toastr, TRANSLATION, UNPROCESSABLE_ENTITY_RESPONSE_CODE, useEffect, useNavbarStatus,
        useQueryClient, useRouter, useState, useTranslation, Yup, ErrorPages, CustomToastrAction, Checkbox, InputText, DefaultCheckbox, CheckedCheckbox, AutocompleteError} from '@/imports-files/common/common';
// ----------------- Common Library -----------------


// ----------------- Actions ---------------------
export {InputError} from '@/actions/common/input-error';
export {nextStep, AdminClientNewAction} from '@/actions/pages/admins/dashboard/clients/new';
export {handleOtherResponseCode} from '@/actions/common/response-handler';
// ----------------- Action ---------------------


// --------------------Services----------
export {SendRequest} from '@/services/common/send-request';
export {Client} from '@/services/pages/admins/dashboard/clients/new';
// ------------------Services-----------


// -----------------------------  CONSTANTS -----------------------------
export {INITIAL_VALUES, VALIDATION_SCHEMA, CONSTANTS} from '@/constants/pages/admins/dashboard/clients/new';
// -----------------------------  CONSTANTS -----------------------------


// ----------------- Stylesheet ---------------------
export { default as PageStyle} from '@/styles/pages/admins/dashboard/clients/new/_index.module.scss';
export { default as PopupStyle} from '@/styles/components/congrats/_index.module.scss';
// ----------------- Stylesheet ---------------------
